import { Button } from '@maxtropy/components';
import { useNavigate } from 'react-router-dom';

const FooterCancelBtn = () => {
  const navigate = useNavigate();
  return <Button onClick={() => navigate('/microgrid/conf/page', { replace: true })}>返回</Button>;
};

export default FooterCancelBtn;
